import React, { useEffect, ReactNode } from "react";
import HeaderOperator from "./HeaderOperator";
import FooterOperator from "./FooterOperator";

type HeadProps = { title: string };
type LayoutProps = { children?: ReactNode; title?: string };

const Head: React.FC<HeadProps> = ({ title }) => {
  useEffect(() => {
    document.title = title;
  }, [title]);

  return null;
};

const OperatorLayout = ({ children, title = "" }: LayoutProps) => (
  <>
    <Head title={title} />
    <>
      <HeaderOperator />

      <main className="mt-[53px] xl:mt-[58px]">{children}</main>

      <FooterOperator />
    </>
  </>
);

export default OperatorLayout;
